import { Styles } from '@chakra-ui/theme-tools'

export const styles: Styles = {
  global: (props) => ({
    body: {
      WebkitFontSmoothing: 'antialiased',
      TextRendering: 'optimizelegibility',
    },
  }),
}
